import { gql } from '@apollo/client';

const CREATE_INSURANCE = gql`
  mutation createInsurance($createInsuranceInput: CreateInsuranceInput!) {
    createInsurance(createInsuranceInput: $createInsuranceInput) {
      insuranceId
    }
  }
`;

const UPDATE_INSURANCE = gql`
  mutation updateInsurance($updateInsuranceInput: UpdateInsuranceInput!) {
    updateInsurance(updateInsuranceInput: $updateInsuranceInput) {
      insuranceId
    }
  }
`;

const GET_INSURANCE_VOUCHER = gql`
  query insuranceVoucher {
    insuranceVoucher
  }
`;

const GET_SIMULATION = gql`
  query getSimulation {
    getSimulation {
      deductible
      insuranceProvider
      period
      monthlyValue
      productId
      responseId
      monthlyValueInUF
      coverageDetails
      paymentType
      installments
      name
      useType
      coverageType
    }
  }
`;

const GET_ZURICH_SIMULATION = gql`
  query getZurichSimulation {
    getZurichSimulation {
      deductible
      PdfUrl
      insuranceProvider
      period
      monthlyValue
      monthlyValueInUF
      internalProductId
      paymentType
      installments
      responseId
      productId
      coverageDetails
      name
      useType
      coverageType
    }
  }
`;

const GET_BCI_SIMULATION = gql`
  query getBciSimulation {
    getBciSimulation {
      deductible
      PdfUrl
      insuranceProvider
      period
      monthlyValue
      internalProductId
      responseId
      productId
      monthlyValueInUF
      coverageDetails
      paymentType
      installments
      name
      useType
      coverageType
    }
  }
`;

const GET_HDI_SIMULATION = gql`
  query getHdiSimulation {
    getHdiSimulation {
      deductible
      insuranceProvider
      PdfUrl
      period
      monthlyValue
      productId
      internalProductId
      responseId
      paymentType
      installments
      monthlyValueInUF
      coverageDetails
      name
      useType
      coverageType
    }
  }
`;
const GET_INSURANCE = gql`
  query getInsurance {
    getInsurance {
      insuranceId
      insuranceProposal {
        proposalProductId
        proposalInternalWebPageUrl
        proposalInternalId
      }
      selectedInsuranceProducts {
        productId
        responseId
        deductible
        insuranceProvider
        period
        PdfUrl
        coverageDetails
        installments
        name
        monthlyValue
        monthlyValueInUF
        paymentType
        useType
        coverageType
      }
      insuranceInput {
        carPlate
        insuranceInterest
        useType
        paymentType
        name
        firstSurname
        rut
        commune
        address
        addressNumber
        businessName
        phone
        email
      }
    }
  }
`;

const CREATE_PROPOSAL = gql`
  mutation createProposal($createProposalInput: CreateProposalInput!) {
    createProposal(createProposalInput: $createProposalInput)
  }
`;

const GET_POLICY = gql`
  query getPolicy {
    getPolicy
  }
`;

const insuranceOperations = {
  GET_INSURANCE,
  CREATE_PROPOSAL,
  GET_POLICY,
  GET_HDI_SIMULATION,
  GET_BCI_SIMULATION,
  GET_ZURICH_SIMULATION,
  GET_SIMULATION,
  GET_INSURANCE_VOUCHER,
  CREATE_INSURANCE,
  UPDATE_INSURANCE,
};

export default insuranceOperations;
